import ListView from '../views/ListView';
import GridView from '../views/GridView';
import KanbanView from '../views/KanbanView';
import AnalyticsView from '../views/AnalyticsView';

export default [{
  key: 'list',
  name: 'List',
  component: ListView,
  componentKey: 'ListView',
  icon: 'view_list',
}, {
  key: 'grid',
  name: 'Grid',
  component: GridView,
  componentKey: 'GridView',
  icon: 'view_module',
}, {
  key: 'kanban',
  name: 'Kanban',
  component: KanbanView,
  componentKey: 'KanbanView',
  icon: 'view_column',
}, {
  key: 'analytics',
  name: 'Analytics',
  component: AnalyticsView,
  componentKey: 'AnalyticsView',
  icon: 'assessment',
}];

export const getIconForView = (view) => {
  switch (view) {
    case 'list':
      return 'view_list';
    case 'grid':
      return 'view_module';
    case 'kanban':
      return 'view_column';
    case 'analytics':
      return 'assessment';
    default:
      return 'view_list';
  }
};

